import { addStyles } from 'ethcss'
import { IStyles, mediaCSS } from 'theme'
import grid from 'blocks.simple/grid/grid.jcss'

export const statusStyles: IStyles = {
    status: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 12,
        width: '26%',
        height: 24,
        border: '4px solid transparent',
        borderRadius: '7px',

        [mediaCSS.desktopML]: {
            width: '30%',

            [mediaCSS.desktop]: {
                height: 18,
                fontSize: 10,
            },
        },
    },
    statusList: {
        width: '26% !important',
    },
    disable: {
        opacity: 0.4,
    },
    main: {
        ...grid.flex,
        ...grid.normalCenter,
        ...grid.center,
        width: '100%',
    },
    statusText: {
        display: 'block',
        verticalAlign: 'middle',
    },
    marker: {
        marginRight: 5,
        verticalAlign: 'middle',
    },
}

addStyles(statusStyles)
